var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.121,
    height: 17,
    viewBox: "0 0 19.121 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-export",
    d: "M6.375,10.359a.8.8,0,0,1,.8-.8H12.75V5.313H8.5A1.063,1.063,0,0,1,7.438,4.25V0H1.594A1.594,1.594,0,0,0,0,1.594V15.406A1.594,1.594,0,0,0,1.594,17h9.563a1.594,1.594,0,0,0,1.594-1.594v-4.25H7.172A.8.8,0,0,1,6.375,10.359ZM8.5,0V4.25h4.25ZM18.863,9.8,16.207,7.139A.8.8,0,0,0,15.08,8.266l1.326,1.3H12.75v1.594h3.656l-1.3,1.3a.78.78,0,0,0-.235.563.8.8,0,0,0,1.36.563l2.656-2.656A.776.776,0,0,0,18.863,9.8Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExport);
export default __webpack_public_path__ + "static/media/file-export.71face452827927ad276f11adfdd0443.svg";
export { ForwardRef as ReactComponent };